<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 6.75753C5 3.94664 7.23857 1.66797 10 1.66797C12.7614 1.66797 15 3.94664 15 6.75753C15 9.54638 13.4042 12.8007 10.9143 13.9645C10.3339 14.2358 9.66608 14.2358 9.08567 13.9645C6.59582 12.8007 5 9.54638 5 6.75753ZM10 8.33464C10.9205 8.33464 11.6667 7.58844 11.6667 6.66797C11.6667 5.74749 10.9205 5.0013 10 5.0013C9.0795 5.0013 8.33333 5.74749 8.33333 6.66797C8.33333 7.58844 9.0795 8.33464 10 8.33464Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.02406 12.1119C3.23843 12.3824 3.19288 12.7755 2.92233 12.9899C2.44428 13.3687 2.29297 13.7025 2.29297 13.9583C2.29297 14.1608 2.38487 14.4068 2.66017 14.6913C2.93829 14.9789 3.37282 15.271 3.96427 15.5393C5.00948 16.0133 6.45423 16.3722 8.1263 16.5286V16.1458C8.1263 15.9006 8.26972 15.6781 8.49305 15.5768C8.71638 15.4754 8.9783 15.514 9.16289 15.6755L10.4129 16.7693C10.5485 16.8879 10.6263 17.0594 10.6263 17.2396C10.6263 17.4198 10.5485 17.5913 10.4129 17.71L9.16289 18.8038C8.9783 18.9652 8.71638 19.0038 8.49305 18.9025C8.26972 18.8012 8.1263 18.5786 8.1263 18.3333V17.7837C6.30557 17.6239 4.67569 17.2345 3.44796 16.6777C2.76975 16.37 2.18521 15.9983 1.76167 15.5604C1.33531 15.1196 1.04297 14.5783 1.04297 13.9583C1.04297 13.1665 1.51519 12.51 2.14605 12.0102C2.4166 11.7958 2.8097 11.8413 3.02406 12.1119ZM16.9786 12.1119C17.1929 11.8413 17.586 11.7958 17.8566 12.0102C18.4874 12.51 18.9596 13.1665 18.9596 13.9583C18.9596 15.1068 17.9862 15.9672 16.8375 16.5428C15.6361 17.1448 13.9938 17.5709 12.1476 17.7581C11.8042 17.7928 11.4976 17.5427 11.4628 17.1993C11.4281 16.8558 11.6782 16.5493 12.0216 16.5144C13.7696 16.3373 15.2525 15.9389 16.2775 15.4253C17.3551 14.8853 17.7096 14.3389 17.7096 13.9583C17.7096 13.7025 17.5583 13.3687 17.0803 12.9899C16.8097 12.7755 16.7642 12.3824 16.9786 12.1119Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'AddressChangeRequestsIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>